/* =====================================
   TECHNOW — Countdown (global)
   Gère toutes les instances .tnw-countdown[data-deadline]
   - multi-sections, multi-pages
   - safe en Theme Editor (section:load)
   ===================================== */
(function(){
  if (window.__tnwCountdownLoaded) return;
  window.__tnwCountdownLoaded = true;

  const parse = (s) => {
    const d = new Date(s);
    return isNaN(+d) ? null : d;
  };

  function render(el, left){
    if (left <= 0){
      const action = el.dataset.expiredAction || 'message';
      const msg    = el.dataset.expiredText || 'Offre terminée';
      if (action === 'hide') el.style.display = 'none';
      else el.textContent = msg;
      el.dataset.done = '1';
      return false;
    }
    const t = Math.floor(left/1000);
    const d = Math.floor(t/86400);
    const h = Math.floor((t%86400)/3600);
    const m = Math.floor((t%3600)/60);
    const s = t%60;
    el.textContent = `${d}J-${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
    return true;
  }

  function scan() {
    return Array.from(document.querySelectorAll('.tnw-countdown[data-deadline]'))
      .filter(el => el.dataset.bound !== '1');
  }

  function bindNewTimers(timers){
    timers.forEach(el => { el.dataset.bound = '1'; });
  }

  function tick(){
    const now = Date.now();
    let active = 0;
    document.querySelectorAll('.tnw-countdown[data-deadline]').forEach(el => {
      if (el.dataset.done === '1') return;
      const deadline = parse(el.dataset.deadline);
      if (!deadline){
        el.textContent = '—';
        el.dataset.done = '1';
        return;
      }
      const cont = render(el, deadline - now);
      if (cont) active++;
    });
    if (active === 0 && window.__tnwCountdownInterval){
      clearInterval(window.__tnwCountdownInterval);
      window.__tnwCountdownInterval = null;
    }
  }

  function ensureLoop(){
    if (window.__tnwCountdownInterval) return;
    window.__tnwCountdownInterval = setInterval(tick, 1000);
    tick();
  }

  function init(){
    const newly = scan();
    if (newly.length){
      bindNewTimers(newly);
      ensureLoop();
    }
  }

  // First pass
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor events (Shopify)
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);

  // Fallback: observe future inserts (ajax, etc.)
  const mo = new MutationObserver(() => init());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();